var city = {
  citycode: [],
  adcode: "360000",
  name: "江西省",
  center: {
    lng: 115.816587,
    lat: 28.637234
  },
  districtList: [
    {
      citycode: "0790",
      adcode: "360500",
      name: "新余市",
      center: {
        lng: 114.916665,
        lat: 27.818553
      },
      districtList: [
        {
          citycode: "0790",
          adcode: "360502",
          name: "渝水区",
          center: {
            lng: 114.944499,
            lat: 27.799526
          }
        },
        {
          citycode: "0790",
          adcode: "360521",
          name: "分宜县",
          center: {
            lng: 114.69264,
            lat: 27.814723
          }
        }
      ]
    },
    {
      citycode: "0791",
      adcode: "360100",
      name: "南昌市",
      center: {
        lng: 115.857972,
        lat: 28.682976
      },
      districtList: [
        {
          citycode: "0791",
          adcode: "360104",
          name: "青云谱区",
          center: {
            lng: 115.925709,
            lat: 28.62182
          }
        },
        {
          citycode: "0791",
          adcode: "360111",
          name: "青山湖区",
          center: {
            lng: 115.962138,
            lat: 28.682867
          }
        },
        {
          citycode: "0791",
          adcode: "360124",
          name: "进贤县",
          center: {
            lng: 116.242468,
            lat: 28.377627
          }
        },
        {
          citycode: "0791",
          adcode: "360102",
          name: "东湖区",
          center: {
            lng: 115.903576,
            lat: 28.698787
          }
        },
        {
          citycode: "0791",
          adcode: "360113",
          name: "红谷滩区",
          center: {
            lng: 115.858127,
            lat: 28.698188
          }
        },
        {
          citycode: "0791",
          adcode: "360112",
          name: "新建区",
          center: {
            lng: 115.815244,
            lat: 28.693192
          }
        },
        {
          citycode: "0791",
          adcode: "360123",
          name: "安义县",
          center: {
            lng: 115.549158,
            lat: 28.845585
          }
        },
        {
          citycode: "0791",
          adcode: "360121",
          name: "南昌县",
          center: {
            lng: 115.93349,
            lat: 28.557921
          }
        },
        {
          citycode: "0791",
          adcode: "360103",
          name: "西湖区",
          center: {
            lng: 115.876998,
            lat: 28.657005
          }
        }
      ]
    },
    {
      citycode: "0796",
      adcode: "360800",
      name: "吉安市",
      center: {
        lng: 114.96681,
        lat: 27.091243
      },
      districtList: [
        {
          citycode: "0796",
          adcode: "360822",
          name: "吉水县",
          center: {
            lng: 115.135963,
            lat: 27.229697
          }
        },
        {
          citycode: "0796",
          adcode: "360825",
          name: "永丰县",
          center: {
            lng: 115.421599,
            lat: 27.317301
          }
        },
        {
          citycode: "0796",
          adcode: "360802",
          name: "吉州区",
          center: {
            lng: 114.994991,
            lat: 27.144204
          }
        },
        {
          citycode: "0796",
          adcode: "360828",
          name: "万安县",
          center: {
            lng: 114.759746,
            lat: 26.456821
          }
        },
        {
          citycode: "0796",
          adcode: "360830",
          name: "永新县",
          center: {
            lng: 114.242425,
            lat: 26.945157
          }
        },
        {
          citycode: "0796",
          adcode: "360823",
          name: "峡江县",
          center: {
            lng: 115.316567,
            lat: 27.5829
          }
        },
        {
          citycode: "0796",
          adcode: "360881",
          name: "井冈山市",
          center: {
            lng: 114.289563,
            lat: 26.748132
          }
        },
        {
          citycode: "0796",
          adcode: "360824",
          name: "新干县",
          center: {
            lng: 115.386853,
            lat: 27.740368
          }
        },
        {
          citycode: "0796",
          adcode: "360821",
          name: "吉安县",
          center: {
            lng: 114.908337,
            lat: 27.039866
          }
        },
        {
          citycode: "0796",
          adcode: "360827",
          name: "遂川县",
          center: {
            lng: 114.520825,
            lat: 26.313413
          }
        },
        {
          citycode: "0796",
          adcode: "360803",
          name: "青原区",
          center: {
            lng: 115.014836,
            lat: 27.082012
          }
        },
        {
          citycode: "0796",
          adcode: "360826",
          name: "泰和县",
          center: {
            lng: 114.922987,
            lat: 26.801687
          }
        },
        {
          citycode: "0796",
          adcode: "360829",
          name: "安福县",
          center: {
            lng: 114.619818,
            lat: 27.393286
          }
        }
      ]
    },
    {
      citycode: "0795",
      adcode: "360900",
      name: "宜春市",
      center: {
        lng: 114.416826,
        lat: 27.816245
      },
      districtList: [
        {
          citycode: "0795",
          adcode: "360981",
          name: "丰城市",
          center: {
            lng: 115.771131,
            lat: 28.160053
          }
        },
        {
          citycode: "0795",
          adcode: "360926",
          name: "铜鼓县",
          center: {
            lng: 114.354623,
            lat: 28.513291
          }
        },
        {
          citycode: "0795",
          adcode: "360922",
          name: "万载县",
          center: {
            lng: 114.445477,
            lat: 28.106201
          }
        },
        {
          citycode: "0795",
          adcode: "360902",
          name: "袁州区",
          center: {
            lng: 114.42794,
            lat: 27.796344
          }
        },
        {
          citycode: "0795",
          adcode: "360921",
          name: "奉新县",
          center: {
            lng: 115.400624,
            lat: 28.688254
          }
        },
        {
          citycode: "0795",
          adcode: "360983",
          name: "高安市",
          center: {
            lng: 115.366863,
            lat: 28.448054
          }
        },
        {
          citycode: "0795",
          adcode: "360982",
          name: "樟树市",
          center: {
            lng: 115.546174,
            lat: 28.054632
          }
        },
        {
          citycode: "0795",
          adcode: "360925",
          name: "靖安县",
          center: {
            lng: 115.362635,
            lat: 28.861296
          }
        },
        {
          citycode: "0795",
          adcode: "360924",
          name: "宜丰县",
          center: {
            lng: 114.803036,
            lat: 28.394466
          }
        },
        {
          citycode: "0795",
          adcode: "360923",
          name: "上高县",
          center: {
            lng: 114.948045,
            lat: 28.238591
          }
        }
      ]
    },
    {
      citycode: "0797",
      adcode: "360700",
      name: "赣州市",
      center: {
        lng: 114.933494,
        lat: 25.831139
      },
      districtList: [
        {
          citycode: "0797",
          adcode: "360735",
          name: "石城县",
          center: {
            lng: 116.347611,
            lat: 26.31491
          }
        },
        {
          citycode: "0797",
          adcode: "360730",
          name: "宁都县",
          center: {
            lng: 116.009171,
            lat: 26.470865
          }
        },
        {
          citycode: "0797",
          adcode: "360731",
          name: "于都县",
          center: {
            lng: 115.415145,
            lat: 25.952564
          }
        },
        {
          citycode: "0797",
          adcode: "360781",
          name: "瑞金市",
          center: {
            lng: 116.027114,
            lat: 25.88623
          }
        },
        {
          citycode: "0797",
          adcode: "360725",
          name: "崇义县",
          center: {
            lng: 114.308135,
            lat: 25.682278
          }
        },
        {
          citycode: "0797",
          adcode: "360734",
          name: "寻乌县",
          center: {
            lng: 115.638534,
            lat: 24.969513
          }
        },
        {
          citycode: "0797",
          adcode: "360729",
          name: "全南县",
          center: {
            lng: 114.530148,
            lat: 24.742353
          }
        },
        {
          citycode: "0797",
          adcode: "360783",
          name: "龙南市",
          center: {
            lng: 114.804474,
            lat: 24.901216
          }
        },
        {
          citycode: "0797",
          adcode: "360726",
          name: "安远县",
          center: {
            lng: 115.393992,
            lat: 25.136855
          }
        },
        {
          citycode: "0797",
          adcode: "360733",
          name: "会昌县",
          center: {
            lng: 115.809271,
            lat: 25.58734
          }
        },
        {
          citycode: "0797",
          adcode: "360722",
          name: "信丰县",
          center: {
            lng: 114.922485,
            lat: 25.38676
          }
        },
        {
          citycode: "0797",
          adcode: "360704",
          name: "赣县区",
          center: {
            lng: 115.021196,
            lat: 25.854496
          }
        },
        {
          citycode: "0797",
          adcode: "360728",
          name: "定南县",
          center: {
            lng: 115.027908,
            lat: 24.783372
          }
        },
        {
          citycode: "0797",
          adcode: "360724",
          name: "上犹县",
          center: {
            lng: 114.55177,
            lat: 25.784754
          }
        },
        {
          citycode: "0797",
          adcode: "360702",
          name: "章贡区",
          center: {
            lng: 114.920426,
            lat: 25.818247
          }
        },
        {
          citycode: "0797",
          adcode: "360723",
          name: "大余县",
          center: {
            lng: 114.362306,
            lat: 25.401968
          }
        },
        {
          citycode: "0797",
          adcode: "360703",
          name: "南康区",
          center: {
            lng: 114.765044,
            lat: 25.661369
          }
        },
        {
          citycode: "0797",
          adcode: "360732",
          name: "兴国县",
          center: {
            lng: 115.363475,
            lat: 26.338129
          }
        }
      ]
    },
    {
      citycode: "0798",
      adcode: "360200",
      name: "景德镇市",
      center: {
        lng: 117.184892,
        lat: 29.2744
      },
      districtList: [
        {
          citycode: "0798",
          adcode: "360222",
          name: "浮梁县",
          center: {
            lng: 117.214984,
            lat: 29.352493
          }
        },
        {
          citycode: "0798",
          adcode: "360202",
          name: "昌江区",
          center: {
            lng: 117.182648,
            lat: 29.273683
          }
        },
        {
          citycode: "0798",
          adcode: "360203",
          name: "珠山区",
          center: {
            lng: 117.271365,
            lat: 29.305191
          }
        },
        {
          citycode: "0798",
          adcode: "360281",
          name: "乐平市",
          center: {
            lng: 117.151499,
            lat: 28.978521
          }
        }
      ]
    },
    {
      citycode: "0793",
      adcode: "361100",
      name: "上饶市",
      center: {
        lng: 117.943064,
        lat: 28.45513
      },
      districtList: [
        {
          citycode: "0793",
          adcode: "361130",
          name: "婺源县",
          center: {
            lng: 117.861532,
            lat: 29.248491
          }
        },
        {
          citycode: "0793",
          adcode: "361125",
          name: "横峰县",
          center: {
            lng: 117.596433,
            lat: 28.407116
          }
        },
        {
          citycode: "0793",
          adcode: "361123",
          name: "玉山县",
          center: {
            lng: 118.244736,
            lat: 28.681936
          }
        },
        {
          citycode: "0793",
          adcode: "361181",
          name: "德兴市",
          center: {
            lng: 117.594549,
            lat: 28.930557
          }
        },
        {
          citycode: "0793",
          adcode: "361124",
          name: "铅山县",
          center: {
            lng: 117.734742,
            lat: 28.298415
          }
        },
        {
          citycode: "0793",
          adcode: "361103",
          name: "广丰区",
          center: {
            lng: 118.189729,
            lat: 28.463697
          }
        },
        {
          citycode: "0793",
          adcode: "361126",
          name: "弋阳县",
          center: {
            lng: 117.449346,
            lat: 28.378039
          }
        },
        {
          citycode: "0793",
          adcode: "361127",
          name: "余干县",
          center: {
            lng: 116.695787,
            lat: 28.70283
          }
        },
        {
          citycode: "0793",
          adcode: "361104",
          name: "广信区",
          center: {
            lng: 117.907454,
            lat: 28.448893
          }
        },
        {
          citycode: "0793",
          adcode: "361102",
          name: "信州区",
          center: {
            lng: 117.965997,
            lat: 28.430694
          }
        },
        {
          citycode: "0793",
          adcode: "361129",
          name: "万年县",
          center: {
            lng: 117.058445,
            lat: 28.694582
          }
        },
        {
          citycode: "0793",
          adcode: "361128",
          name: "鄱阳县",
          center: {
            lng: 116.703731,
            lat: 29.005675
          }
        }
      ]
    },
    {
      citycode: "0799",
      adcode: "360300",
      name: "萍乡市",
      center: {
        lng: 113.887147,
        lat: 27.658721
      },
      districtList: [
        {
          citycode: "0799",
          adcode: "360302",
          name: "安源区",
          center: {
            lng: 113.87072,
            lat: 27.615
          }
        },
        {
          citycode: "0799",
          adcode: "360321",
          name: "莲花县",
          center: {
            lng: 113.961589,
            lat: 27.128498
          }
        },
        {
          citycode: "0799",
          adcode: "360322",
          name: "上栗县",
          center: {
            lng: 113.795294,
            lat: 27.880221
          }
        },
        {
          citycode: "0799",
          adcode: "360323",
          name: "芦溪县",
          center: {
            lng: 114.029351,
            lat: 27.631273
          }
        },
        {
          citycode: "0799",
          adcode: "360313",
          name: "湘东区",
          center: {
            lng: 113.733047,
            lat: 27.640075
          }
        }
      ]
    },
    {
      citycode: "0792",
      adcode: "360400",
      name: "九江市",
      center: {
        lng: 115.95356,
        lat: 29.66116
      },
      districtList: [
        {
          citycode: "0792",
          adcode: "360404",
          name: "柴桑区",
          center: {
            lng: 115.911005,
            lat: 29.608775
          }
        },
        {
          citycode: "0792",
          adcode: "360483",
          name: "庐山市",
          center: {
            lng: 116.045118,
            lat: 29.448225
          }
        },
        {
          citycode: "0792",
          adcode: "360402",
          name: "濂溪区",
          center: {
            lng: 115.992735,
            lat: 29.668008
          }
        },
        {
          citycode: "0792",
          adcode: "360428",
          name: "都昌县",
          center: {
            lng: 116.203999,
            lat: 29.273803
          }
        },
        {
          citycode: "0792",
          adcode: "360426",
          name: "德安县",
          center: {
            lng: 115.767114,
            lat: 29.298599
          }
        },
        {
          citycode: "0792",
          adcode: "360403",
          name: "浔阳区",
          center: {
            lng: 116.001677,
            lat: 29.70547
          }
        },
        {
          citycode: "0792",
          adcode: "360423",
          name: "武宁县",
          center: {
            lng: 115.092649,
            lat: 29.246785
          }
        },
        {
          citycode: "0792",
          adcode: "360424",
          name: "修水县",
          center: {
            lng: 114.546536,
            lat: 29.026166
          }
        },
        {
          citycode: "0792",
          adcode: "360430",
          name: "彭泽县",
          center: {
            lng: 116.563858,
            lat: 29.877404
          }
        },
        {
          citycode: "0792",
          adcode: "360429",
          name: "湖口县",
          center: {
            lng: 116.252206,
            lat: 29.731194
          }
        },
        {
          citycode: "0792",
          adcode: "360482",
          name: "共青城市",
          center: {
            lng: 115.784269,
            lat: 29.235082
          }
        },
        {
          citycode: "0792",
          adcode: "360425",
          name: "永修县",
          center: {
            lng: 115.83207,
            lat: 29.011392
          }
        },
        {
          citycode: "0792",
          adcode: "360481",
          name: "瑞昌市",
          center: {
            lng: 115.681221,
            lat: 29.676026
          }
        }
      ]
    },
    {
      citycode: "0794",
      adcode: "361000",
      name: "抚州市",
      center: {
        lng: 116.358054,
        lat: 27.948979
      },
      districtList: [
        {
          citycode: "0794",
          adcode: "361025",
          name: "乐安县",
          center: {
            lng: 115.83099,
            lat: 27.428682
          }
        },
        {
          citycode: "0794",
          adcode: "361024",
          name: "崇仁县",
          center: {
            lng: 116.076363,
            lat: 27.754416
          }
        },
        {
          citycode: "0794",
          adcode: "361028",
          name: "资溪县",
          center: {
            lng: 117.060332,
            lat: 27.706088
          }
        },
        {
          citycode: "0794",
          adcode: "361021",
          name: "南城县",
          center: {
            lng: 116.637228,
            lat: 27.570031
          }
        },
        {
          citycode: "0794",
          adcode: "361030",
          name: "广昌县",
          center: {
            lng: 116.336556,
            lat: 26.843974
          }
        },
        {
          citycode: "0794",
          adcode: "361027",
          name: "金溪县",
          center: {
            lng: 116.755018,
            lat: 27.91973
          }
        },
        {
          citycode: "0794",
          adcode: "361026",
          name: "宜黄县",
          center: {
            lng: 116.236174,
            lat: 27.554744
          }
        },
        {
          citycode: "0794",
          adcode: "361023",
          name: "南丰县",
          center: {
            lng: 116.525898,
            lat: 27.21845
          }
        },
        {
          citycode: "0794",
          adcode: "361022",
          name: "黎川县",
          center: {
            lng: 116.907446,
            lat: 27.282729
          }
        },
        {
          citycode: "0794",
          adcode: "361003",
          name: "东乡区",
          center: {
            lng: 116.603159,
            lat: 28.249059
          }
        },
        {
          citycode: "0794",
          adcode: "361002",
          name: "临川区",
          center: {
            lng: 116.311932,
            lat: 27.935098
          }
        }
      ]
    },
    {
      citycode: "0701",
      adcode: "360600",
      name: "鹰潭市",
      center: {
        lng: 117.039532,
        lat: 28.272092
      },
      districtList: [
        {
          citycode: "0701",
          adcode: "360602",
          name: "月湖区",
          center: {
            lng: 117.10247,
            lat: 28.266999
          }
        },
        {
          citycode: "0701",
          adcode: "360681",
          name: "贵溪市",
          center: {
            lng: 117.245178,
            lat: 28.292397
          }
        },
        {
          citycode: "0701",
          adcode: "360603",
          name: "余江区",
          center: {
            lng: 116.854576,
            lat: 28.199657
          }
        }
      ]
    }
  ]
};

export default city;



// WEBPACK FOOTER //
// ./src/util/province/jiangxi.js